module.exports = __webpack_public_path__ + "static/media/wendyMock.069cb5ce.jpg";